<script>
import {mapActions, mapGetters} from "vuex";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import AppLoading from "@/components/elements/AppLoading.vue";
export default {
  name: "ShipsPiRightship",
  components: {AppLoading},
  mixins: [PaginationMixin],
  data(){
    return {
      loading : true,
      params : {
        fleet_id: null,
      },
      modalTitle: null,
      modalType: null,
      modalContent: [],
    }
  },
  methods:{
    ...mapActions([
      'getVesselsRightshipInspections',
    ]),
    async setData(page = 1) {
      this.loading = true;
      this.params.page = page;
      await this.getVesselsRightshipInspections(this.params);
      this.loading = false;
    },
    showRightshipInspectionModal(type, data, title, year) {
      this.modalContent = data;
      this.modalType = type;
      this.modalTitle = title+" ("+year+")";
      $('#rightshipModal').modal('show');
    },
    goToReport(reportId){
      if(this.modalType === 'findings'){
        const route = this.$router.resolve(
          {
            name: 'NonConformityDetail',
            params: {
              id: reportId,
            },
          },
        )
        window.open(route.href,'_blank')
      }
      else{
        const route = this.$router.resolve(
          {
            name: 'RsMain',
            params: {
              id: reportId,
            },
          },
        )
        window.open(route.href,'_blank')
      }

    }
  },
  computed: {
    ...mapGetters([
      'vesselRightshipInspectionInspections','pagination','fleetKeys',
    ]),
  },
  watch: {
    'params.search'() {
      this.setVesselsData()
    },
    'params.fleet_id'() {
      this.setData()
    },
  },
  async created(){
    this.setVesselsData = _.debounce(this.setData, 750)
    await this.setData();
  }
}
</script>

<template>
<div class="container-fluid px-0 py-4">
  <div class="row mt-2">
    <div class="col-12">
      <div class="card">
        <div class="card-header pt-3 pb-3 bg-white">
          <span class="text-uppercase h6 font-weight-bold text-danger">Number of Inspection</span>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-12">
              <nav aria-label="...">
                <ul class="pagination text-smallest mb-0 pb-0">
                  <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                    <button class="page-link" @click="setData(1)">First</button>
                  </li>

                  <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                    <button class="page-link" @click="setData(page)">{{ page }}</button>
                  </li>

                  <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                    <button class="page-link" @click="setData(pagination.lastPage)">Last</button>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="row">
                <div class="col-4 d-flex align-items-center justify-content-end pr-1">
                  <span class="font-weight-bold">Filter By:</span>
                </div>
                <div class="col-8 pl-1">
                  <select class="form-control form-control-sm text-uppercase" id="fleetList" v-model="params.fleet_id">
                    <option :value="null">-- ALL FLEET --</option>
                    <template v-for="fleet in fleetKeys">
                      <option :value="fleet.id" v-if="[1, 2, 3, 4, 5, 6].includes(fleet.id) && fleet?.name !== 'N/A' && fleet.code !== 'N/A'">
                        {{fleet.name ? fleet.name.toUpperCase() : ''}}
                      </option>
                    </template>
                  </select>
                </div>

              </div>

            </div>
            <div class="col-lg-4 col-md-4 col-sm-12">
              <input type="text" name="vesselSearch" class="form-control form-control-sm" v-model="params.search" placeholder="Search Vessel">
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-12">
              <div class="table-responsive" style="max-height: 60vh;">
                <template v-if="loading">
                  <app-loading></app-loading>
                </template>
                <template v-if="vesselRightshipInspectionInspections.length === 0 && !loading">
                  <div class="card" style="background-color: #e1e1e1">
                    <div class="card-body text-center">
                      <span class="font-weight-bold h6" style="color: black">NO RESULTS FOUND</span>
                    </div>
                  </div>
                </template>
                <table class="table table-bordered  table-inspection" v-if="!loading && vesselRightshipInspectionInspections.length !== 0" >
                  <thead>
                    <tr>
                      <th rowspan="3" class="inspection-headers align-middle text-center text-uppercase dark-bottom-side-border" style="max-width: 200px !important;">Vessel Name</th>
                      <template v-for="(data, index) in vesselRightshipInspectionInspections[0]?.rs">
                        <th colspan="2" class="inspection-headers align-middle text-center text-uppercase dark-bottom-side-border">{{ data.year }}</th>
                      </template>
                    </tr>
                    <tr>
                      <template v-for="(data, index) in vesselRightshipInspectionInspections[0]?.rs">
                        <th class="inspection-headers align-middle text-center text-uppercase dark-bottom-side-border">Nbr Inspection</th>
                        <th class="deficiency-ins-headers align-middle text-center text-uppercase dark-bottom-side-border">No. of Findings</th>
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(data, index) in vesselRightshipInspectionInspections" :key="index">
                    <td class="text-right font-weight-bold align-middle normal-headers dark-right-side-border" style="min-width: 170px !important;">{{ data.name }}</td>
                    <template v-for="(item, indexRs) in data.rs">
                      <td v-if="item.rs.nbr_without_nonconformity.length !== 0" class="text-center font-weight-bold align-middle text-primary h5" style="cursor: pointer" @click="showRightshipInspectionModal('inspection',item.rs.nbr_without_nonconformity,data.name,item.year)">{{item.rs.nbr_without_nonconformity.length}}</td>
                      <td v-else class="text-center font-weight-bold align-middle">{{item.rs.nbr_without_nonconformity.length}}</td>
                      <td v-if="item.rs.nbr_with_nonconformity.length !== 0" class="text-center font-weight-bold align-middle text-primary h5" style="cursor: pointer" @click="showRightshipInspectionModal('findings',item.rs.nbr_with_nonconformity,data.name,item.year)">
                        {{
                          item.rs.nbr_with_nonconformity.reduce(
                            (total, inspection) => total + (inspection.non_conformity_count || 0),
                            0
                          )
                        }}
                      </td>
                      <td v-else class="text-center font-weight-bold align-middle">{{item.rs.nbr_with_nonconformity.length}}</td>
                    </template>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- RIGHTSHIP MODAL -->
          <div class="modal fade" id="rightshipModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title my-auto font-weight-bold text-uppercase" id="exampleModalLabel">{{ this.modalTitle }}</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-12">
                      <table class="table table-bordered w-100">
                        <thead>
                        <tr v-if="this.modalType === 'inspection'">
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">#</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Code</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Report Title</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Inspection Date</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Action</th>
                        </tr>
                        <tr v-else>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">#</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Code</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Title</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">RISQ Code</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">RISQ Finding</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Description</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Inspection Date</th>
                          <th class="align-middle text-center text-uppercase normal-headers h6 font-weight-bold border-0">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-if="this.modalType === 'inspection'">
                          <tr v-for="(data, index) in modalContent">
                            <td class="align-middle text-center">{{index+1}}</td>
                            <td class="align-middle text-center">{{data.code}}</td>
                            <td class="align-middle text-center">{{data.title}}</td>
                            <td class="align-middle text-center">{{data.inspection_commencement_date}}</td>
                            <td class="align-middle text-center">
                              <button class="e-btn e-btn-blue e-btn-sm e-text-white" @click="goToReport(data.id)">
                                <font-awesome-icon icon="eye"  />
                                View
                              </button>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <template v-for="(data, index) in modalContent">
                            <tr v-for="(item, indexDef) in data.non_conformity" :key="`${index}-${indefDef}`">
                              <td class="align-middle text-center no-rows">
                                {{modalContent.slice(0, index).reduce((acc, prev) => acc + prev.non_conformity.length, 0) + indexDef + 1 }}
                              </td>
                              <td class="align-middle text-center">{{data.code}}</td>
                              <td class="align-middle text-center">{{data.title}}</td>
                              <td class="align-middle text-center">{{item.rsn_question?.code}}</td>
                              <td class="align-middle text-center">{{item.rsn_question?.main_question}}</td>
                              <td class="align-middle text-center"><div v-html="item?.description"></div>
                              </td>
                              <template v-if="indexDef === 0">
                                <td class="align-middle text-center" :rowspan="data.non_conformity.length">{{data.inspection_commencement_date}}</td>
                              </template>
                              <td class="align-middle text-center">
                                <button class="e-btn e-btn-blue e-btn-sm e-text-white" @click="goToReport(data.id)">
                                  <font-awesome-icon icon="eye"  />
                                  View
                                </button>
                              </td>
                            </tr>
                          </template>
                        </template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--END RIGHTSHIP MODAL  -->
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<style scoped>
.table-inspection td:nth-child(1),
.table-inspection th
{
  position: sticky;
  left: 0;
  z-index: 5;
}
.table-inspection th{
  z-index: 10;
}
.table-inspection tr:nth-child(1) th:nth-child(1){
  z-index: 99;
}
.table-inspection tr:nth-child(1) th,
.table-inspection td:nth-child(1)
{
  outline-offset: -1px ;
}
.table-inspection tr:nth-child(1) th {  outline: 3px solid #b3b3b3 ; }
.table-inspection td:nth-child(1) { outline: 2px solid #b3b3b3 ; }
.table-inspection tr:nth-child(1) th {  top:0; }
.table-inspection tr:nth-child(2) th{ top:43px; }
.inspection-headers{
  background-color: #2E75B5;
  color: #f2f2f2;
}
.deficiency-ins-headers{
  background-color: #C55911;
  color: #f2f2f2;
}
.normal-headers{
  background-color: #e1e1e1;
  border: 1px solid #c3c3c3;
}
.dark-left-side-border{
  border-left: 3px solid #b3b3b3;
}
.dark-right-side-border{
  border-right: 3px solid #b3b3b3;
}
.dark-bottom-side-border{
  border-bottom: 3px solid #b3b3b3;
}
.dark-top-side-border{
  border-top: 3px solid #b3b3b3;
}
.dark-border{
  border: 3px solid #b3b3b3;
}
</style>
